import React from 'react';
import { Trans } from 'react-i18next';
import { SmallTitle } from '../../../components/Base/Title';
import SkeletonItem from '../../../components/SkeletonItem';

import { Button } from '@ets-global/b2c-website-ui';

const AddressesListSkeleton = () => {
  return (
    <>
      <div className="basket__addresses">
        <SmallTitle>
          <Trans>session-summary.addresses.label</Trans>
        </SmallTitle>
        <div className="basket__addresses-list">
          <div className="basket__addresses-item">
            <SkeletonItem style={{ height: 209, width: '100%' }} />
          </div>
          <div className="basket__addresses-item">
            <SkeletonItem style={{ height: 209, width: '100%' }} />
          </div>
        </div>
      </div>
      <div className="basket__block-actions">
        <div>
          <SkeletonItem style={{ height: 20, width: 740, marginBottom: 25 }} />
          <div className={'basket__block-actions-buttons'}>
            <Button className={'skeleton-item'}>
              <div style={{ width: 10, height: 16 }} />
            </Button>
            <Button className={'skeleton-item'}>
              <div style={{ width: 150, height: 16 }} />
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddressesListSkeleton;
